import { useState, useEffect } from "react";
import { MdAssistant, MdGroup, MdGroups, MdPerson } from "react-icons/md";
import { MdOutlineFeaturedPlayList, MdOutlineFavoriteBorder } from "react-icons/md";
import { getTeams } from "../../api/team-admin";
import { getUserID, getUserRole } from "../service";
import { getUserTeams } from "../../api/userApiFunctions";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";


export const ExploreAgentsSideItems = () => {
  
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);

  const role = getUserRole();
  const userId = getUserID();

  useEffect(() => {
    const fetchTeams = async () => {
      setLoading(true);
      try {
        let response;

        if (role === "admin" || role === "superadmin") {
          response = await getTeams(1, 10);
        } else {
          response = await getUserTeams(userId); 
        }

        if (response.success && Array.isArray(response.data)) {
          const formattedTeams = response.data.map((team) => ({
            id: team._id,
            name: team.teamTitle,
          }));
          setTeams(formattedTeams);
        } else {
          console.warn("Unexpected API response structure:", response);
        }
      } catch (error) {
        console.error("Fetch Teams Error:", error);
      }

      setLoading(false);
    };

    fetchTeams();
  }, [role, userId])

  return [
    
    { key: "1", icon: <MdAssistant />, label: "All Agents", id: "all-agents-btn" },
    { key: "2", icon: <MdOutlineFeaturedPlayList />, label: "Featured Agents", id: "featured-agents-btn" },
    { key: "3", icon: <MdOutlineFavoriteBorder />, label: "Favorite Agents", id: "favorite-agents-btn" },  
    { key: "4", icon: <MdGroup />, label: "Organizational Agent", id: "org-agents-btn" },
    { key: "5", icon: <MdPerson />, label: "My Agents", id: "my-agents-btn" },
    { key: "6", icon: <MdPerson />, label: "Industry Agents", id: "my-agents-btn" },
    {
      key: "7",
      icon: <MdGroups size={20} />,
      label: "Department Agents",
      id: "team-agents-btn",
      className: "team-list-container",
      "data-menu-id": "team-agents",
      children: loading
        ? [{ key: "loading", label: <div className="team-loading">Loading...</div> }]
        : teams.length > 0
        ? teams.map((team) => ({
            key: `team-${team.id}`,
            label: (
              <div
                onClick={() => setSelectedTeam(team.id)}
                className={`team-item ${selectedTeam === team.id ? "selected" : ""}`}
              >
                <span className="team-arrow">
                  {selectedTeam === team.id ? (
                    <MdKeyboardArrowDown size={20} />
                  ) : (
                    <MdKeyboardArrowRight size={20} />
                  )}
                </span>
                {team.name}
              </div>
            ),
          }))
        : [{ key: "no-teams", label: <div className="team-empty">No Departments Found</div> }],
    }
  ];
};
